import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import LoginView from 'views/page/loggin/login';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import styled from 'styled-components';
import { onChangeLoad } from './redux/reducer/loadReducer';
import Vacancies from './views/page/vacancies';
import VacancyForm from './views/page/vacancyForm';
import Companies from './views/page/companies';
import SideNav from './views/components/sideNav';
import { palette } from './system/styles/styles';
import { startLogout } from './redux/actions/auth_actions';
import PrivateRoute from './system/router/privateRoute';
import ModalLoad from './views/components/modal/modalLoad';
import ATS from './views/page/atsOne';
import ForgortPass from './views/page/loggin/forgotPass';

import 'react-notifications/lib/notifications.css';
import '@progress/kendo-theme-default/dist/all.css';
import unisATSRoutes from './system/router';

const MainStyle = styled.main`
  display: grid;
  ${(props) => (props.uid ? `grid-template-columns: 170px 1fr;` : ` `)}
  min-height: 100vh !important;
  background-color: ${palette.white};
  overflow: hidden;
  p,
  h1,
  h2,
  h3,
  h4,
  input,
  span,
  li,
  ol,
  a,
  header,
  button,
  label {
    font-family: ${palette.nereg};
    letter-spacing: 0.5px;
  }
`;

export default function AppRouter() {
  const { uid } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  React.useEffect(() => dispatch(onChangeLoad(true)), []);

  const logout = () => {
    dispatch(startLogout());
    history.push(unisATSRoutes.MAIN);
  };

  // React.useEffect(() => {
  //   window.$crisp = [];
  //   window.CRISP_WEBSITE_ID = '04e5e200-dc66-4f52-b21c-d20935f55213';
  //   (function () {
  //     const d = document;
  //     const s = d.createElement('script');
  //     s.src = 'https://client.crisp.chat/l.js';
  //     s.async = 1;
  //     d.getElementsByTagName('head')[0].appendChild(s);
  //   })();
  // }, []);

  return (
    <MainStyle uid={uid}>
      <ModalLoad />
      {uid ? <SideNav logout={logout} /> : null}
      <Switch>
        {/* Rutas privadas, solicita el auth para poder entrar a estas rutas */}
        <PrivateRoute exact path={unisATSRoutes.VACANCIES} component={Vacancies} />
        <PrivateRoute exact path={unisATSRoutes.COMPANIES} component={Companies} />
        <PrivateRoute exact path={unisATSRoutes.FORMVACANCYADD} component={VacancyForm} />
        <PrivateRoute exact path={unisATSRoutes.ATS} component={ATS} />
        {/* Fin de las rutas privadas */}
        <Route exact path={unisATSRoutes.MAIN} component={LoginView} />
        <Route exact path={unisATSRoutes.ForgotPass} component={ForgortPass} />
        {/* <Redirect to={unisATSRoutes.MAIN} /> */}
      </Switch>
      <NotificationContainer />
    </MainStyle>
  );
}
